export default __webpack_public_path__ + "static/media/hometex.138c0bca.jpg";